var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHearing = function SvgHearing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Hearing_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0.294,
    y: 3.002,
    width: 16,
    height: 23,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.294 3.002h16v23h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.683 25a3.85 3.85 0 0 1-3.846-3.847.277.277 0 1 1 .554 0 3.296 3.296 0 0 0 3.292 3.292 3.294 3.294 0 0 0 3.107-2.21c.048-.128.084-.234.114-.345.68-2.47 2.053-4.165 2.962-5.287.17-.21.324-.4.456-.574a6.955 6.955 0 0 0 1.684-4.53 6.951 6.951 0 0 0-6.944-6.943 6.902 6.902 0 0 0-6.242 3.9.277.277 0 0 1-.498-.243 7.452 7.452 0 0 1 6.74-4.211c4.134 0 7.497 3.363 7.497 7.497 0 1.788-.642 3.52-1.806 4.879-.125.165-.283.36-.457.574-.88 1.086-2.209 2.727-2.858 5.086a4.082 4.082 0 0 1-.128.387A3.846 3.846 0 0 1 6.683 25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.683 25a3.85 3.85 0 0 1-3.846-3.847.277.277 0 1 1 .554 0 3.296 3.296 0 0 0 3.292 3.292 3.294 3.294 0 0 0 3.107-2.21c.048-.128.084-.234.114-.345.68-2.47 2.053-4.165 2.962-5.287.17-.21.324-.4.456-.574a6.955 6.955 0 0 0 1.684-4.53 6.951 6.951 0 0 0-6.944-6.943 6.902 6.902 0 0 0-6.242 3.9.277.277 0 0 1-.498-.243 7.452 7.452 0 0 1 6.74-4.211c4.134 0 7.497 3.363 7.497 7.497 0 1.788-.642 3.52-1.806 4.879-.125.165-.283.36-.457.574-.88 1.086-2.209 2.727-2.858 5.086a4.082 4.082 0 0 1-.128.387A3.846 3.846 0 0 1 6.683 25Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.683 25a3.85 3.85 0 0 1-3.846-3.847.277.277 0 1 1 .554 0 3.296 3.296 0 0 0 3.292 3.292 3.294 3.294 0 0 0 3.107-2.21c.048-.128.084-.234.114-.345.68-2.47 2.053-4.165 2.962-5.287.17-.21.324-.4.456-.574a6.955 6.955 0 0 0 1.684-4.53 6.951 6.951 0 0 0-6.944-6.943 6.902 6.902 0 0 0-6.242 3.9.277.277 0 0 1-.498-.243 7.452 7.452 0 0 1 6.74-4.211c4.134 0 7.497 3.363 7.497 7.497 0 1.788-.642 3.52-1.806 4.879-.125.165-.283.36-.457.574-.88 1.086-2.209 2.727-2.858 5.086a4.082 4.082 0 0 1-.128.387A3.846 3.846 0 0 1 6.683 25Z",
    stroke: "#102B3F",
    strokeWidth: 0.4,
    mask: "url(#Hearing_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "Hearing_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 3.317,
    y: 7.375,
    width: 9,
    height: 14,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.317 7.375h9v14h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.605 20.487a2.03 2.03 0 0 1-.728-.136 2.093 2.093 0 0 1-1.324-2.104c.017-.214.1-.475.207-.804.253-.788.601-1.868.198-2.915-.624-1.622-.79-2.766-.51-3.497.4-1.037 1.124-1.852 2.04-2.294.924-.446 1.98-.48 2.972-.1 1.431.55 2.388 1.88 2.496 3.472a.277.277 0 1 1-.552.037c-.094-1.373-.915-2.52-2.143-2.991-.849-.326-1.748-.297-2.533.081-.788.38-1.414 1.089-1.762 1.994-.226.589-.055 1.632.51 3.099.472 1.23.074 2.466-.189 3.284-.091.283-.17.528-.181.678-.052.669.347 1.304.97 1.543.384.148.807.13 1.19-.053.388-.184.69-.513.848-.926a.277.277 0 0 1 .517.199c-.21.546-.61.982-1.127 1.227a2.098 2.098 0 0 1-.899.206Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.605 20.487a2.03 2.03 0 0 1-.728-.136 2.093 2.093 0 0 1-1.324-2.104c.017-.214.1-.475.207-.804.253-.788.601-1.868.198-2.915-.624-1.622-.79-2.766-.51-3.497.4-1.037 1.124-1.852 2.04-2.294.924-.446 1.98-.48 2.972-.1 1.431.55 2.388 1.88 2.496 3.472a.277.277 0 1 1-.552.037c-.094-1.373-.915-2.52-2.143-2.991-.849-.326-1.748-.297-2.533.081-.788.38-1.414 1.089-1.762 1.994-.226.589-.055 1.632.51 3.099.472 1.23.074 2.466-.189 3.284-.091.283-.17.528-.181.678-.052.669.347 1.304.97 1.543.384.148.807.13 1.19-.053.388-.184.69-.513.848-.926a.277.277 0 0 1 .517.199c-.21.546-.61.982-1.127 1.227a2.098 2.098 0 0 1-.899.206Z",
    fill: "#102B3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.605 20.487a2.03 2.03 0 0 1-.728-.136 2.093 2.093 0 0 1-1.324-2.104c.017-.214.1-.475.207-.804.253-.788.601-1.868.198-2.915-.624-1.622-.79-2.766-.51-3.497.4-1.037 1.124-1.852 2.04-2.294.924-.446 1.98-.48 2.972-.1 1.431.55 2.388 1.88 2.496 3.472a.277.277 0 1 1-.552.037c-.094-1.373-.915-2.52-2.143-2.991-.849-.326-1.748-.297-2.533.081-.788.38-1.414 1.089-1.762 1.994-.226.589-.055 1.632.51 3.099.472 1.23.074 2.466-.189 3.284-.091.283-.17.528-.181.678-.052.669.347 1.304.97 1.543.384.148.807.13 1.19-.053.388-.184.69-.513.848-.926a.277.277 0 0 1 .517.199c-.21.546-.61.982-1.127 1.227a2.098 2.098 0 0 1-.899.206Z",
    stroke: "#102B3F",
    strokeWidth: 0.4,
    mask: "url(#Hearing_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "Hearing_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 13.525,
    y: 3.168,
    width: 5,
    height: 16,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.525 3.168h5v16h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.802 18.24a.277.277 0 0 1-.196-.473c3.62-3.62 3.62-9.507 0-13.126a.277.277 0 0 1 .392-.392c3.835 3.835 3.835 10.075 0 13.91a.277.277 0 0 1-.196.08Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.802 18.24a.277.277 0 0 1-.196-.473c3.62-3.62 3.62-9.507 0-13.126a.277.277 0 0 1 .392-.392c3.835 3.835 3.835 10.075 0 13.91a.277.277 0 0 1-.196.08Z",
    fill: "#102B3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.802 18.24a.277.277 0 0 1-.196-.473c3.62-3.62 3.62-9.507 0-13.126a.277.277 0 0 1 .392-.392c3.835 3.835 3.835 10.075 0 13.91a.277.277 0 0 1-.196.08Z",
    stroke: "#102B3F",
    strokeWidth: 0.4,
    mask: "url(#Hearing_svg__c)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "Hearing_svg__d",
    maskUnits: "userSpaceOnUse",
    x: 15.256,
    y: 1.502,
    width: 6,
    height: 19,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.256 1.502h6v19h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.532 20.152a.277.277 0 0 1-.196-.473 11.734 11.734 0 0 0 3.46-8.352c0-3.155-1.228-6.121-3.46-8.352a.277.277 0 0 1 .393-.392 12.284 12.284 0 0 1 3.621 8.743c0 3.303-1.286 6.41-3.622 8.745a.275.275 0 0 1-.196.08v.001Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.532 20.152a.277.277 0 0 1-.196-.473 11.734 11.734 0 0 0 3.46-8.352c0-3.155-1.228-6.121-3.46-8.352a.277.277 0 0 1 .393-.392 12.284 12.284 0 0 1 3.621 8.743c0 3.303-1.286 6.41-3.622 8.745a.275.275 0 0 1-.196.08v.001Z",
    fill: "#102B3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.532 20.152a.277.277 0 0 1-.196-.473 11.734 11.734 0 0 0 3.46-8.352c0-3.155-1.228-6.121-3.46-8.352a.277.277 0 0 1 .393-.392 12.284 12.284 0 0 1 3.621 8.743c0 3.303-1.286 6.41-3.622 8.745a.275.275 0 0 1-.196.08v.001Z",
    stroke: "#102B3F",
    strokeWidth: 0.4,
    mask: "url(#Hearing_svg__d)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "Hearing_svg__e",
    maskUnits: "userSpaceOnUse",
    x: 16.939,
    y: 0,
    width: 6,
    height: 23,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.939 0h6v23h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.215 21.933a.277.277 0 0 1-.196-.473c5.511-5.51 5.511-14.477 0-19.987a.277.277 0 0 1 .392-.392c5.727 5.726 5.727 15.044 0 20.77a.277.277 0 0 1-.196.082Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.215 21.933a.277.277 0 0 1-.196-.473c5.511-5.51 5.511-14.477 0-19.987a.277.277 0 0 1 .392-.392c5.727 5.726 5.727 15.044 0 20.77a.277.277 0 0 1-.196.082Z",
    fill: "#102B3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.215 21.933a.277.277 0 0 1-.196-.473c5.511-5.51 5.511-14.477 0-19.987a.277.277 0 0 1 .392-.392c5.727 5.726 5.727 15.044 0 20.77a.277.277 0 0 1-.196.082Z",
    stroke: "#102B3F",
    strokeWidth: 0.4,
    mask: "url(#Hearing_svg__e)"
  })));
};

export default SvgHearing;